import { Pipe, PipeTransform } from "@angular/core";
import { UntypedFormGroup, Validators } from "@angular/forms";
import { jsonParse } from "../app.component";

export function jsonDeepParse(str) {
  try {
    if (str) {
      str = jsonParse(str);
      if (str && str.length && typeof str == 'object') {
        str.forEach(element => {
          element = jsonDeepParse(element);
        });
      }
      else if (str && typeof str == 'object') {
        let keys = Object.keys(str);
        if (keys && keys.length) {
          keys.forEach(key => {
            str[key] = jsonDeepParse(str[key]);
          });
        }
      }
      return str;
    }
    else {
      return str;
    }
  }
  catch (e) {
    return str;
  }
}


export function setDefaultValue(formGroup: UntypedFormGroup, controlName, list: any[], property,) {
  try {
    list.forEach(item => {
      if (item && item['isDefault']) {
        formGroup.controls[controlName].patchValue(item[property]);
      }
    })
  }
  catch (err) {

  }

}

export function getInvalidFields(form_group: UntypedFormGroup, translate, notification_srv, json_root_property, do_not_translate?, is_offer_onb_obj?) {
  if (form_group && form_group.controls) {
    let all_controls = Object.keys(form_group.controls);
    for (let i = 0; i < all_controls.length; i++) {
      if (form_group.controls[all_controls[i]].errors) {
        let err
        if (form_group.controls[all_controls[i]].errors) {
          if (form_group.controls[all_controls[i]].errors.required) {
            err = 'ERROR.is_required'
          }
          else if (form_group.controls[all_controls[i]].errors.maxlength) {
            err = 'ERROR.max_length';
          }
          else if (form_group.controls[all_controls[i]].errors.minlength) {
            err = 'ERROR.minimum_length';
          }
          else if (form_group.controls[all_controls[i]].errors.min) {
            err = 'ERROR.min_value'
          }
          else if (form_group.controls[all_controls[i]].errors.max) {
            err = 'ERROR.max_value'
          }
          else {
            err = 'ERROR.invalid_input'
          }
          if (!do_not_translate) {
            translate.get([json_root_property + all_controls[i], err]).subscribe(res => {
              let message;
              let cname = res[json_root_property + all_controls[i]];
              let ename = res[err]
              message = cname + ' ' + ename
              notification_srv.error(message, "Close", 5000);
            })
          }
          else {
            translate.get([err]).subscribe(res => {
              let message;
              let cname = all_controls[i];
              let ename = res[err]
              message = cname + ' ' + ename;
              if (is_offer_onb_obj && is_offer_onb_obj[cname]) {
                message = is_offer_onb_obj[cname]['label'] + ' ' + ename;
              }
              notification_srv.error(message, "Close", 5000);
            })
          }



        }
        break;
      }
    }
  }
}


export function setValidators(field, form) {
  try {
    // form.get(field.title).setValidators([Validators.required, Validators.minLength(field.minLength), Validators.maxLength(field.maxLength), Validators.pattern(field.pattern), Validators.min(field.min), Validators.max(field.max)])

    let validators = [];
    //Min and Max length validation

    if (field.minLength != '' && field.minLength != null) {
      validators.push(Validators.minLength(eval(field.minLength)));
    }

    if (field.maxLength != '' && field.maxLength != null) {
      validators.push(Validators.maxLength(eval(field.maxLength)));
    }

    if (field.pattern && field.pattern != '') {
      validators.push(Validators.pattern(field.pattern));
    }

    //Min and Max value validation

    if (field.min != '' && field.min != null) {
      validators.push(Validators.min(eval(field.min)));
    }

    if (field.max != '' && field.max != null) {
      validators.push(Validators.max(eval(field.max)));
    }

    if (field.mandatory != '' && field.mandatory) {
      validators.push(Validators.required);
    }

    form.get(field.title).setValidators(validators);
    form.get(field.title).updateValueAndValidity();
  }
  catch (err) { }
}


export const emailRegEx = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
export const onlyNumbersRegX = "^[0-9]*$";

@Pipe({
  name: 'DynamicPipe'
})
export class DynamicFilterPipe implements PipeTransform {

  transform(code: any, options: any[], id?, title?): Array<any> {
    let out_str = [];
    if (options && options.length) {
      if ((code || code == 0) && typeof (code) == 'number') {
        options.forEach(opt => {
          if (code == opt[id]) {
            out_str.push(opt[title] || '');
            return;
          }
        })
      }
      else if ((code || code == 0) && typeof (code) == 'object') {
        if (code.length > 0) {
          code.forEach(codes => {
            options.forEach(opt => {
              if (codes == opt[id]) {
                out_str.push(opt[title] || '');
                return;
              }
            })
          })

        }

      }
      else if ((code || code == 0) && typeof (code) == 'string') {
        options.forEach(opt => {
          if (opt[id] && code == opt[id]) {
            out_str.push(opt[title] || '');
            return;
          }
        })
      }
    }
    return out_str.length && out_str || code;
  }
}
export function removeDuplicateFromArray(list) {
  return list.filter((element, i) => i === list.indexOf(element))
}
export function copyTextToClipboard(text, notification_srv?, message?) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand('copy');
  document.body.removeChild(textArea);
}

export function hexToRGB(h) {
  let r: any = 0, g: any = 0, b: any = 0;

  try {
    // 3 digits
    if (h.length == 4) {
      r = "0x" + h[1] + h[1];
      g = "0x" + h[2] + h[2];
      b = "0x" + h[3] + h[3];

      // 6 digits
    } else if (h.length == 7) {
      r = "0x" + h[1] + h[2];
      g = "0x" + h[3] + h[4];
      b = "0x" + h[5] + h[6];
    }

    return "rgb(" + +r + "," + +g + "," + +b + ")";
  }
  catch (err) {
    console.log(err)
    return h;
  }

}

export function hexToRGBNumber(h) {
  let r: any = 0, g: any = 0, b: any = 0;

  // 3 digits
  if (h.length == 4) {
    r = "0x" + h[1] + h[1];
    g = "0x" + h[2] + h[2];
    b = "0x" + h[3] + h[3];

    // 6 digits
  } else if (h.length == 7) {
    r = "0x" + h[1] + h[2];
    g = "0x" + h[3] + h[4];
    b = "0x" + h[5] + h[6];
  }

  return +r + "," + +g + "," + +b;
}


export function processValidationObject(slice_string, obj) {
  if (slice_string && obj) {
    let keys = Object.keys(obj);
    keys.forEach(key => {
      if (key.indexOf(slice_string) == 0) {
        obj[key.replace(slice_string, "")] = obj[key];
        delete obj[key];
      }
    });
  }
  return obj;

}

export function setValidatorsForFormControl(section, form_control, validation_obj) {

}
export function preparePortalV2(data, title_srv?) {
  let object = data;
  if (object) {
    if (object.portalFeviconIcon && object.portalFeviconIcon.length) {
      try {
        let el: any = document.getElementById('appIcon');
        if (el) {
          el.href = 'https://storage.googleapis.com/ezeone/icanrefer/' + object.portalFeviconIcon[0].cdnPath;
        }
      }
      catch (err) {
        console.log(err)
      }
      // this.favIcon.href = 'https://storage.googleapis.com/ezeone/icanrefer/' + this.portal_details.banners[0].cdnPath;
    }
    if (object.portalTitle && object.portalTitle != '' && title_srv) {
      title_srv.setTitle(object.portalTitle);
    }
  }
  if (data && data.portalSettings) {
    let object = data.portalSettings;
    if (object) {
      if (object.portalFeviconIcon && object.portalFeviconIcon.length) {
        try {
          let el: any = document.getElementById('appIcon');
          if (el) {
            el.href = 'https://storage.googleapis.com/ezeone/icanrefer/' + object.portalFeviconIcon[0].cdnPath;
          }
        }
        catch (err) {
          console.log(err)
        }
        // this.favIcon.href = 'https://storage.googleapis.com/ezeone/icanrefer/' + this.portal_details.banners[0].cdnPath;
      }

    }
  }
  if (data && data.title != '' && title_srv) {
    title_srv.setTitle(data.title);
  }

}
export function prepareFieldConfigFlagsNew(data, form?, opForm?, spliter?) {

  // let access_rights: any = {}
  // if (data && data.length) {
  //   data.forEach(right => {
  //     let rightsd = prepareDynamicValidationScript(right);
  //     access_rights[right.shortCode] =
  //     {
  //       shortCode: right.shortCode,
  //       validationScript: rightsd,
  //       mandatory: rightsd && rightsd.mandatory
  //     }

  //     if (form && right.validationScript && right.validationScript != '' && right.shortCode && right.shortCode != '') {
  //       try {
  //         setDynamicValidators(rightsd, form, right.shortCode, opForm)
  //       }
  //       catch (err) {
  //         console.log(err)
  //       }
  //     }
  //   })
  //   return access_rights;
  // }
  // else {
  //   return {}
  // }
  let access_rights: any = {}
  if (data && data.length) {
    data.forEach(right => {
      let rightsd = prepareDynamicValidationScriptNew(right) || {};
      rightsd['label'] = right.label;
      rightsd['placeholder'] = right.placeholder;
      let controlName;
      if (spliter && spliter != '' && right.shortCode) {
        let codes = right.shortCode.split(spliter)
        if (codes && codes.length == 2) {
          controlName = codes[1];
        }
        if (controlName) {
          rightsd['controlName'] = controlName
        }
      }
      access_rights[right.shortCode] = rightsd;

      if (form && right.validationScript && right.validationScript != '' && right.shortCode && right.shortCode != '') {
        try {
          if (controlName) {
            setDynamicValidators(rightsd['validationScriptUI'], form, controlName, opForm)
          }
          else {
            setDynamicValidators(rightsd['validationScriptUI'], form, right.shortCode, opForm)
          }
        }
        catch (err) {
          // console.log(err)
        }
      }
    })
    return access_rights;
  }
  else {
    return {}
  }
}
export function setDynamicValidatorsNew(field, form, formControlName, opForm) {
  try {
    // form.get(field.title).setValidators([Validators.required, Validators.minLength(field.minLength), Validators.maxLength(field.maxLength), Validators.pattern(field.pattern), Validators.min(field.min), Validators.max(field.max)])

    let validators = [];
    //Min and Max length validation
    try {
      form.get([formControlName]).clearValidators();
      form.get([formControlName]).updateValueAndValidity();
      if (opForm) {
        try {
          opForm.get([formControlName]).clearValidators();
          opForm.get([formControlName]).updateValueAndValidity();
        }
        catch (err) {
        }

      }
    }
    catch (err) {
      console.log(err)
    }

    if (field.minLength != '' && field.minLength != null) {
      validators.push(Validators.minLength(eval(field.minLength)));
    }

    if (field.maxLength != '' && field.maxLength != null) {
      validators.push(Validators.maxLength(eval(field.maxLength)));
    }

    if (field.pattern && field.pattern != '') {

      validators.push(Validators.pattern(field.pattern));
    }


    //Min and Max value validation

    if (field.min != '' && field.min != null) {
      validators.push(Validators.min(eval(field.min)));
    }

    if (field.max != '' && field.max != null) {
      validators.push(Validators.max(eval(field.max)));
    }

    if (field.mandatory != '' && field.mandatory && field.mandatory != '0') {
      validators.push(Validators.required);
    }
    // console.log(formControlName)
    form.get([formControlName]).setValidators(validators);
    form.get([formControlName]).updateValueAndValidity();
    // console.log(form.get([formControlName]))
    if (opForm) {
      try {
        opForm.get([formControlName]).setValidators(validators);
        opForm.get([formControlName]).updateValueAndValidity();
      }
      catch (err) {
      }

    }
    // console.log(form.get([formControlName]))
  }
  catch (err) {
    // console.log(err + '' + formControlName)
    // console.log(err)

  }
}
export function prepareDynamicValidationScriptNew(field) {
  if (field.validationScript && field.validationScript != '') {
    try {
      field.validationScript = jsonParse(field.validationScript);
      if (field.validationScript && field.validationScript.length) {
        let data = {};
        try {
          field.validationScript.forEach(validation => {
            let keys = Object.keys(validation)
            data[keys[0]] = validation[keys[0]]
          })
          field.validationScriptUI = data;
        }
        catch (err) {
          // console.log(err)
          field.validationScriptUI = {};
          return field
        }
        return field
      }
    }
    catch (err) {
      // console.log(err)
      if (!field.validationScriptUI) {
        field.validationScriptUI = {};
      }
      return field;
    }
  }
  else {
    return field
  }
} export function setDynamicValidators(field, form, formControlName, opForm) {
  try {
    // form.get(field.title).setValidators([Validators.required, Validators.minLength(field.minLength), Validators.maxLength(field.maxLength), Validators.pattern(field.pattern), Validators.min(field.min), Validators.max(field.max)])
    // console.log(field)
    let validators = [];
    //Min and Max length validation
    try {
      form.get([formControlName]).clearValidators();
      form.get([formControlName]).updateValueAndValidity();
      if (opForm) {
        try {
          opForm.get([formControlName]).clearValidators();
          opForm.get([formControlName]).updateValueAndValidity();
        }
        catch (err) {
        }

      }
    }
    catch (err) {
    }

    if (field.minLength != '' && field.minLength != null) {
      validators.push(Validators.minLength(eval(field.minLength)));
    }

    if (field.maxLength != '' && field.maxLength != null) {
      validators.push(Validators.maxLength(eval(field.maxLength)));
    }

    if (field.pattern && field.pattern != '') {

      validators.push(Validators.pattern(field.pattern));
    }


    //Min and Max value validation

    if (field.min != '' && field.min != null) {
      validators.push(Validators.min(eval(field.min)));
    }

    if (field.max != '' && field.max != null) {
      validators.push(Validators.max(eval(field.max)));
    }

    if (field.mandatory != '' && field.mandatory && field.mandatory != '0') {
      validators.push(Validators.required);
    }
    if (opForm) {
      try {
        opForm.get([formControlName]).setValidators(validators);
        opForm.get([formControlName]).updateValueAndValidity();
      }
      catch (err) {
      }

    }
    form.get([formControlName]).setValidators(validators);
    form.get([formControlName]).updateValueAndValidity();
  }
  catch (err) {
    // console.log(err + '' + formControlName)
    // console.log(err)

  }
}
export function prepareValidationScript(field) {
  if (field.validationScript && field.validationScript != '') {
    try {
      let objects = field.validationScript.split(",");
      objects.forEach(o => {
        let arr = o.split("@");
        if (arr && arr.length > 1) {
          field[arr[0].trim()] = arr[1].trim();
          console.log(arr[1].trim())
        }
      })
      return field
    }
    catch (err) {
      console.log(err)
      return field;
    }
  }
}
export function getInvalidFieldsV2(form_group: UntypedFormGroup, translate, notification_srv, json_root_property, do_not_translate?, prepared_fields?, spliter?) {
  if (form_group && form_group.controls) {
    let all_controls = Object.keys(form_group.controls);
    for (let i = 0; i < all_controls.length; i++) {
      if (form_group.controls[all_controls[i]].errors) {
        console.log(all_controls[i])
        let err;
        let controlName;
        let field
        if (prepared_fields) {
          let keys = Object.keys(prepared_fields);
          for (let j = 0; j < keys.length; j++) {
            if (prepared_fields[keys[j]]['controlName'] == all_controls[i]) {
              field = prepared_fields[keys[j]]
              controlName = prepared_fields[keys[j]].label;
              break;
            }
          }
        }
        if (form_group.controls[all_controls[i]].errors) {
          if (form_group.controls[all_controls[i]].errors.required) {
            err = 'ERROR.is_required'
          }
          else if (form_group.controls[all_controls[i]].errors.maxlength) {
            if (field && field.validationScriptUI && field.validationScriptUI.maxLengthErrorMsg) {
              err = field.validationScriptUI.maxLengthErrorMsg;
            }
            else {
              err = 'ERROR.max_length';
            }
          }
          else if (form_group.controls[all_controls[i]].errors.minlength) {
            if (field && field.validationScriptUI && field.validationScriptUI.minLengthErrorMsg) {
              err = field.validationScriptUI.minLengthErrorMsg;
            }
            else {
              err = 'ERROR.minimum_length';
            }
          }
          else if (form_group.controls[all_controls[i]].errors.min) {
            if (field && field.validationScriptUI && field.validationScriptUI.minErrorMsg) {
              err = field.validationScriptUI.minErrorMsg;
            }
            else {
              err = 'ERROR.min_value'
            }
          }
          else if (form_group.controls[all_controls[i]].errors.max) {
            if (field && field.validationScriptUI && field.validationScriptUI.maxErrorMsg) {
              err = field.validationScriptUI.maxErrorMsg;
            }
            else {
              err = 'ERROR.max_value'
            }
          }
          else {
            if (field && field.validationScriptUI && field.validationScriptUI.patternErrorMsg) {
              err = field.validationScriptUI.patternErrorMsg;
            }
            else {
              err = 'ERROR.invalid_input'
            }
          }
          if (!prepared_fields) {
            if (!do_not_translate) {
              translate.get([json_root_property + all_controls[i], err]).subscribe(res => {
                let message;
                let cname = res[json_root_property + all_controls[i]];
                let ename = res[err]
                message = cname + ' ' + ename
                notification_srv.error(message, "Close", 5000);
              })
            }
            else {
              translate.get([err]).subscribe(res => {
                let message;
                let cname = all_controls[i];
                let ename = res[err]
                message = cname + ' ' + ename
                notification_srv.error(message, "Close", 5000);
              })
            }
          }
          else {
            translate.get([json_root_property + all_controls[i], err]).subscribe(res => {
              let message;
              console.log(res)
              if (!controlName) {
                controlName = res[json_root_property + all_controls[i]];
              }
              if (controlName) {
                let cname = controlName;
                let ename = res[err]
                message = cname + ' ' + ename
                notification_srv.error(message, "Close", field && field.validationScriptUI && field.validationScriptUI.duration || 5000);
              }
              else {
                notification_srv.error('ERROR.please_fill_mandatory_fields', "Close", 5000);
              }

            })
          }




        }
        break;
      }
    }

  }
}


@Pipe({
  name: 'dateAgo',
  pure: true
})
export class DateAgoPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
      if (seconds < 29) // less than 30 seconds ago will show as 'Just now'
        return 'Just now';
      const intervals = {
        'year': 31536000,
        'month': 2592000,
        'week': 604800,
        'day': 86400,
        'hour': 3600,
        'minute': 60,
        'second': 1
      };
      let counter;
      for (const i in intervals) {
        counter = Math.floor(seconds / intervals[i]);
        if (counter > 0)
          if (counter === 1) {
            return counter + ' ' + i + ' ago'; // singular (1 day ago)
          } else {
            return counter + ' ' + i + 's ago'; // plural (2 days ago)
          }
      }
    }
    return value;
  }

}
export function toUTCDate(date) { //convert UTC to local dont go on name
  if (date) {
    return new Date(date + ' UTC')
  }
  else {
    return null
  }
}


export function replaceAll(mailStrBody, tagTerm, replaceFromResult) {
  // console.log(mailStrBody)
  // console.log(tagTerm)
  // console.log(replaceFromResult)
  if (mailStrBody && tagTerm && typeof mailStrBody == 'string') {
    // if(mailStrBody.type =='object'){
    //     mailStrBody = JSON.stringify(mailStrBody)
    // }
    let value: any = mailStrBody.replace(new RegExp(escapeRegExp(tagTerm), 'g'), replaceFromResult);
    try {
      if (value) {
        var dateReg = /^\d{4}([./-])\d{2}\1\d{2}$/;
        var dateReg2 = /^\d{2}([./-])\d{2}\1\d{4}$/;
        if (value.match(dateReg)) {
          value = new Date(value)
          return value;
        }
        else if (value.match(dateReg2)) {
          var newdate = value.split("-").reverse().join("-");
          value = new Date(newdate)
        }
      }
    }
    catch (err) {
      console.log(value)
      console.log(err)
    }
    return value;
  } else {
    let value = mailStrBody;
    try {
      if (value && typeof value == 'string') {
        var dateReg = /^\d{4}([./-])\d{2}\1\d{2}$/;
        var dateReg2 = /^\d{2}([./-])\d{2}\1\d{4}$/;
        value.match(dateReg);
        if (value.match(dateReg)) {
          value = new Date(value)
        }
        else if (value.match(dateReg2)) {
          var newdate: any = value.split("-").reverse().join("-");
          value = new Date(newdate)
        }
      }
    }
    catch (err) {
      console.log(value)
      console.log(err)
    }
    return value;
  }
}
export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}


export function deepMergeObjects(target, source) {
  const mergedObject = { ...target };

  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      if (Array.isArray(source[key])) {
        // If the property is an array, replace it entirely
        mergedObject[key] = source[key];
      } else if (source[key] instanceof Object && key in target && target[key] instanceof Object) {
        // If the property is an object, recursively merge it
        mergedObject[key] = deepMergeObjects(target[key], source[key]);
      } else {
        // Otherwise, replace the property value
        mergedObject[key] = source[key];
      }
    }
  }

  return mergedObject;
}